import { useTranslate } from 'core/hooks/useTranslate';
import { useEffect, useMemo, useState } from 'react';

const SCHEDULE_ACTION_VALUES = ['schedule', 'scheduled'];

function useFooterAutoSaving({ saveStatus = 'idle', actionSelected, options = [] }) {
  const { t } = useTranslate();
  const [isVisible, setIsVisible] = useState(false);

  // Determine if the component should be shown
  const shouldShow = useMemo(() => {
    // If saveStatus is explicitly set to something other than 'idle', respect that
    // If saveStatus is 'idle' (default), show the component for backward compatibility
    return true;
  }, [saveStatus]);

  const shouldShowDateSchedule = useMemo(
    () => SCHEDULE_ACTION_VALUES.includes(actionSelected) && options.length > 0,
    [actionSelected, options.length]
  );

  // Determine the icon type based on save status
  const iconType = useMemo(() => {
    switch (saveStatus) {
      case 'saving':
        return 'upload-cloud';
      case 'saved':
        return 'auto-saved';
      case 'idle':
        return '';
      default:
        return 'auto-saved'; // Default icon for backward compatibility
    }
  }, [saveStatus]);

  // Determine the status text based on save status
  const statusText = useMemo(() => {
    switch (saveStatus) {
      case 'saving':
        return t('lesson:Saving');
      case 'saved':
        return t('lesson:Saved a few seconds ago');
      case 'idle':
        return '';
      default:
        return t('lesson:Saved a few seconds ago'); // Default text for backward compatibility
    }
  }, [saveStatus, t]);

  useEffect(() => {
    if (shouldShow) {
      // Trigger animation on mount with a small delay for smooth effect
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 50);

      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [shouldShow]);

  return {
    t,
    isVisible,
    iconType,
    statusText,
    shouldShow,
    shouldShowDateSchedule,
  };
}

export default useFooterAutoSaving;
